<template>
  <v-app>
    <v-app-bar app dense dark color="teal">
      <v-toolbar-title dark class="headline text-uppercase">
        <span>ADAM</span>
      </v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items v-if="$base.isAllowed('watch')">
        <v-btn
          text
          color="white"
          to="/"
        >
          Builds
        </v-btn>
        <v-btn
          text
          color="white"
          to="/map"
        >
          Map
        </v-btn>
        <v-btn
          text
          color="white"
          to="/charts"
        >
          Charts
        </v-btn>
        <v-menu
          bottom
          left
          z-index="99999"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              color="white"
              v-bind="attrs"
              v-on="on"
            >
              Telemetry
              <v-icon>{{ mdiMenuDown }}</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/telemetry/statistic">
              <v-list-item-title>
                Statistic
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/telemetry/feedback">
              <v-list-item-title>
                Feedback
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/telemetry/config-statistic">
              <v-list-item-title>
                Config Statistic
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/telemetry/hardware-statistic">
              <v-list-item-title>
                Hardware Statistic
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/telemetry/frogwares-playtests">
              <v-list-item-title>
                Frogwares playtests
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/telemetry/marketing/PCMaster">
              <v-list-item-title>
                Marketing
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          bottom
          left
          z-index="99999"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>{{ mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/levels-statistic">
              <v-list-item-title>
                Levels Statistic
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/maps-parser">
              <v-list-item-title>
                Maps parser
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="/combat-test">
              <v-list-item-title>
                Combat test
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          bottom
          left
          z-index="99999"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              text
              color="white"
              v-on="on"
            >
              {{ currProjectName }}
              <v-icon>{{ mdiMenuDown }}</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(project, i) in projects"
              :key="i"
              @click="setCurrentProject(project.id)"
            >
              <v-list-item-title>{{ project.project_name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          text
          color="white"
          to="/admin/map/global"
        >
          <v-icon>{{ mdiCog }}</v-icon>
        </v-btn>
        <v-btn
          text
          color="white"
          @click="logout"
        >
          <v-icon>{{ mdiLogout }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <component :is="layout">
        <router-view />
      </component>
    </v-content>
  </v-app>
</template>

<script>
import basePerimeter from './perimeters/base';
import { mapActions } from 'vuex';
import { mdiMenuDown, mdiCog, mdiLogout, mdiDotsVertical }  from '@mdi/js';

export default {
  name: 'App',
  perimeters: [
    basePerimeter
  ],
  data () {
    return {
      mdiMenuDown,
      mdiCog,
      mdiLogout,
      mdiDotsVertical
    }
  },
  computed: {
    projectPath () {
      return this.$store.getters.projectPath
    },
    projects() {
      return this.$store.state.projects;
    },
    currProjectName() {
      return this.$store.state.currProject.project_name;
    },
    layout() {
      return this.$route.meta.layout || 'default-layout';
    }
  },
  async created() {
    if (this.$base.isAllowed('logined')) {
      await this.$store.dispatch('getPlatforms');
      await this.$store.dispatch('getEnums');
    }
  },
  methods: {
    ...mapActions([
      'setCurrentProject'
    ]),
    async logout() {
      localStorage.clear()
      await this.$store.dispatch('logout')
      this.$nextTick(() => {
        this.$router.push('/login')
      })
    }
  }
};
</script>

<style lang="css">
  .v-application code {
    background-color: inherit !important;
    color: inherit !important;
  }
</style>